export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14255.3988daa9.jpg";